import useSelectedFilterSet from '../../../../hooks/useSelectedFilterSet';
import {
  StyledFilterSetFilters,
  StyledFilterSetWrapper
} from './FilterSetWrapper.style';
import FilterSetHeader from './FilterSetHeader/FilterSetHeader';
import { useContext, useEffect, useState } from 'react';
import { boolPropsToClassNames } from 'common/utils/style.utils';
import { isEmpty } from 'lodash';

const FilterSetWrapper = ({ Context, children }) => {
  const {
    state: { filters, selectedFilterSetId }
  } = useContext(Context);
  const isEmptyFilters = isEmpty(filters);
  const [isCollapsed, setIsCollapsed] = useState(!isEmptyFilters);
  const selectedFilterSet = useSelectedFilterSet(Context);

  useEffect(() => {
    setIsCollapsed(!isEmptyFilters);
  }, [selectedFilterSetId]);

  if (!selectedFilterSet) return children;

  return (
    <StyledFilterSetWrapper>
      <FilterSetHeader
        Context={Context}
        isCollapsed={isCollapsed}
        toggleCollapse={() => setIsCollapsed(prev => !prev)}
      />

      <StyledFilterSetFilters
        className={boolPropsToClassNames({ isCollapsed })}
      >
        {children}
      </StyledFilterSetFilters>
    </StyledFilterSetWrapper>
  );
};

export default FilterSetWrapper;
